export type GossipItem = {
  id: number;
  group: "just" | "today" | "earlier";
  timeLabel: string;
  category: string;
  badges: string[];
  title: string;
  excerpt: string;
  cover: string;
  comments: number;
  shares: number;
  likes: number;
};

export type ColumnItem = {
  id: number;
  name: string;
  desc: string;
  cover: string;
  updates: number;
  watchers: number;
  tone: string;
};

export const heroCover =
  "https://readdy.ai/api/search-image?query=dramatic%20editorial%20entertainment%20scene%20at%20night%2C%20a%20crowd%20of%20onlookers%20in%20shadow%20facing%20a%20bright%20spotlit%20stage%2C%20breaking%20news%20burst%20of%20amber%20and%20deep%20crimson%20lighting%2C%20cinematic%20tabloid%20cover%20mood%2C%20warm%20high%20contrast%2C%20dark%20charcoal%20backdrop%20with%20glowing%20rim%20light%2C%20stylized%20dramatic%20composition%2C%20cohesive%20and%20mysterious&width=1280&height=820&seq=g91-hero&orientation=landscape";

export const feedItems: GossipItem[] = [
  {
    id: 1,
    group: "just",
    timeLabel: "刚刚",
    category: "顶流动态",
    badges: ["热乎", "首发"],
    title: "顶流演唱会深夜彩排被拍离场，歌单疑似大换血",
    excerpt: "现场收音流出的十秒里能听出三首新编曲，老歌粉和新生代阵营已经提前开吵，导播组凌晨仍在改灯位。",
    cover: "https://readdy.ai/api/search-image?query=empty%20arena%20at%20night%20under%20hot%20amber%20stage%20lights%2C%20a%20single%20silhouette%20walking%20across%20the%20dark%20stage%20floor%2C%20spotlight%20beams%20and%20haze%2C%20late%20night%20rehearsal%20mood%2C%20cinematic%20crimson%20and%20gold%20tones%2C%20editorial%20entertainment%20cover%2C%20moody%20charcoal%20background&width=640&height=420&seq=g91-f1&orientation=landscape",
    comments: 438,
    shares: 102,
    likes: 2210,
  },
  {
    id: 2,
    group: "just",
    timeLabel: "3 分钟前",
    category: "综艺现场",
    badges: ["首发"],
    title: "新一季综艺录制路透流出，导师席阵型大洗牌",
    excerpt: "机位图显示开场就有人离席，互选环节直接跳过进入补录，首期播出时间可能提前一周抢档。",
    cover: "https://readdy.ai/api/search-image?query=variety%20show%20studio%20set%20at%20night%20with%20bright%20stage%20lighting%2C%20multiple%20empty%20judge%20chairs%20around%20a%20spotlit%20table%2C%20cameras%20and%20boom%20arms%20in%20shadow%2C%20warm%20amber%20and%20soft%20crimson%20glow%2C%20behind%20the%20scenes%20recording%20mood%2C%20editorial%20entertainment%20cover%2C%20cohesive%20dark%20background&width=640&height=420&seq=g91-f2&orientation=landscape",
    comments: 291,
    shares: 76,
    likes: 1320,
  },
  {
    id: 3,
    group: "just",
    timeLabel: "6 分钟前",
    category: "网红一线",
    badges: ["反转", "热乎"],
    title: "直播连麦翻车名场面，原声片段疯传后被速删",
    excerpt: "被掐断的五分钟原声被逐帧扒出，时间戳和弹幕对得上，删档动作反而把热度顶到前排。",
    cover: "https://readdy.ai/api/search-image?query=glowing%20smartphone%20screen%20held%20by%20a%20hand%20in%20a%20dark%20room%2C%20live%20broadcast%20interface%20reflection%2C%20red%20notification%20light%2C%20night%20city%20bokeh%20behind%2C%20warm%20amber%20and%20crimson%20tones%2C%20viral%20clip%20mood%2C%20editorial%20entertainment%20cover%2C%20dark%20cohesive%20backdrop&width=640&height=420&seq=g91-f3&orientation=landscape",
    comments: 521,
    shares: 233,
    likes: 3050,
  },
  {
    id: 4,
    group: "today",
    timeLabel: "11:27",
    category: "顶流动态",
    badges: ["加更"],
    title: "红毯环节临场加长，后台导播语音被放上台前收音",
    excerpt: "候场区对话混进了现场收音，两句话信息量不小，官方随后改口称是彩排音源。",
    cover: "https://readdy.ai/api/search-image?query=long%20red%20carpet%20glowing%20under%20floodlights%20at%20night%2C%20empty%20with%20golden%20rope%20barriers%2C%20flash%20camera%20bursts%20in%20background%2C%20warm%20amber%20spotlights%20and%20deep%20crimson%20edges%2C%20event%20mood%2C%20editorial%20entertainment%20cover%2C%20dark%20cohesive%20backdrop&width=640&height=420&seq=g91-f4&orientation=landscape",
    comments: 366,
    shares: 88,
    likes: 1980,
  },
  {
    id: 5,
    group: "today",
    timeLabel: "10:52",
    category: "网红一线",
    badges: ["热乎"],
    title: "头部主播带货战绩图表曝光，数据口径引两派站队",
    excerpt: "同一份GMV图两边都拿来当证据，隔屏对线到凌晨，平台数据页卡了半小时。",
    cover: "https://readdy.ai/api/search-image?query=laptop%20screen%20showing%20glowing%20analytics%20charts%20and%20upward%20lines%20in%20a%20dark%20room%2C%20warm%20desk%20lamp%20light%2C%20red%20and%20gold%20chart%20colors%2C%20night%20working%20mood%2C%20editorial%20data%20drama%20cover%2C%20dark%20cohesive%20background%2C%20cinematic%20warm%20lighting&width=640&height=420&seq=g91-f5&orientation=landscape",
    comments: 674,
    shares: 141,
    likes: 4120,
  },
  {
    id: 6,
    group: "today",
    timeLabel: "09:40",
    category: "综艺现场",
    badges: ["反转"],
    title: "真人秀剧本疑云再起，剪辑前后口型被逐帧比对",
    excerpt: "前后两版口型长度对不上，替身与正片并排对比流出，制作组回应称是补录素材混入。",
    cover: "https://readdy.ai/api/search-image?query=video%20editing%20timeline%20on%20a%20dark%20monitor%20with%20film%20frames%20and%20waveforms%2C%20studio%20monitor%20glow%2C%20scissors%20and%20clapperboard%20nearby%2C%20warm%20amber%20lighting%2C%20behind%20the%20scenes%20investigation%20mood%2C%20editorial%20entertainment%20cover%2C%20dark%20cohesive%20backdrop&width=640&height=420&seq=g91-f6&orientation=landscape",
    comments: 480,
    shares: 190,
    likes: 2670,
  },
  {
    id: 7,
    group: "earlier",
    timeLabel: "昨天 23:15",
    category: "舆论反转",
    badges: ["首发"],
    title: "公关通稿上线两小时即被挖旧照，文案撞车成实锤",
    excerpt: "澄清稿里的表述与前年另一份声明逐句相似，评论前排已经盖起对比楼，删改次数被围观。",
    cover: "https://readdy.ai/api/search-image?query=stack%20of%20newsprint%20press%20releases%20and%20memos%20on%20a%20dark%20desk%2C%20warm%20side%20lamp%2C%20magnifying%20glass%20over%20documents%2C%20red%20pen%20mark%2C%20late%20night%20press%20office%20mood%2C%20amber%20and%20crimson%20tones%2C%20editorial%20media%20cover%2C%20dark%20cohesive%20backdrop&width=640&height=420&seq=g91-f7&orientation=landscape",
    comments: 329,
    shares: 118,
    likes: 1760,
  },
  {
    id: 8,
    group: "earlier",
    timeLabel: "昨天 20:03",
    category: "顶流动态",
    badges: ["首发", "热乎"],
    title: "时尚盛典赞助商临时撤换，压轴嘉宾名单连夜重排",
    excerpt: "易拉宝和背板连夜返工，压轴顺序前后互换了两次，红毯开场前十分钟才最终定稿。",
    cover: "https://readdy.ai/api/search-image?query=backstage%20team%20rearranging%20glowing%20brand%20backdrop%20panels%20before%20a%20gala%20at%20night%2C%20people%20in%20shadow%20working%20fast%2C%20spotlight%20and%20gold%20string%20lights%2C%20warm%20amber%20with%20deep%20crimson%2C%20behind%20the%20scenes%20chaos%20mood%2C%20editorial%20entertainment%20cover%2C%20dark%20cohesive%20backdrop&width=640&height=420&seq=g91-f8&orientation=landscape",
    comments: 247,
    shares: 65,
    likes: 1090,
  },
];

export const feedGroups = [
  { key: "just", label: "刚刚出炉" },
  { key: "today", label: "今天已冲" },
  { key: "earlier", label: "昨夜晚瓜" },
];

export const feedCategories = [
  { key: "all", label: "全部速递" },
  { key: "顶流动态", label: "顶流动态" },
  { key: "综艺现场", label: "综艺现场" },
  { key: "网红一线", label: "网红一线" },
  { key: "舆论反转", label: "舆论反转" },
];

export const badgeStyle: Record<string, { cls: string; icon: string }> = {
  首发: { cls: "bg-accent-400 text-background-50", icon: "ri-flashlight-fill" },
  热乎: { cls: "bg-primary-500 text-background-50", icon: "ri-fire-fill" },
  反转: { cls: "bg-secondary-800 text-background-50", icon: "ri-restart-line" },
  加更: { cls: "bg-primary-200 text-primary-900", icon: "ri-arrow-up-double-line" },
};

export const reactionTypes = [
  { key: "吃到了", icon: "ri-flag-2-fill", color: "text-primary-600" },
  { key: "瓜保熟", icon: "ri-shield-check-fill", color: "text-accent-600" },
  { key: "蹲后续", icon: "ri-eye-fill", color: "text-foreground-700" },
];

export type CommentItem = {
  id: number;
  user: string;
  time: string;
  text: string;
  floor: number;
  replies: number;
  votes: number;
};

export const frontComments: CommentItem[] = [
  {
    id: 1,
    user: "前排钉子户",
    time: "1 分钟前",
    text: "第 3 条现场，这次音频我录全了，等会儿整理成图慢慢放，瓜保熟别催。",
    floor: 1,
    replies: 86,
    votes: 12,
  },
  {
    id: 2,
    user: "已蹲两小时",
    time: "4 分钟前",
    text: "注意看时间戳，这段和官方发的不是同一条，剪辑把顺序调过了，反转应该快了。",
    floor: 2,
    replies: 132,
    votes: 8,
  },
  {
    id: 3,
    user: "路转热粉",
    time: "7 分钟前",
    text: "从第一线跟到现在，这条是最硬的料，收藏了蹲个通稿，看看怎么圆。",
    floor: 3,
    replies: 54,
    votes: 3,
  },
  {
    id: 4,
    user: "补课群众",
    time: "9 分钟前",
    text: "有没有老哥把前因后果捋一版，刚进瓜田坐标还没分清，求带路前排看戏。",
    floor: 4,
    replies: 41,
    votes: 1,
  },
];

export type HotItem = {
  id: number;
  rank: number;
  title: string;
  tag: string;
  heat: number;
  delta: "up" | "down" | "new";
};

export const hotRank: HotItem[] = [
  { id: 1, rank: 1, title: "彩排歌单大换血引老粉新粉对线", tag: "顶流", heat: 98, delta: "up" },
  { id: 2, rank: 2, title: "连麦原声删档反而把热度顶上天", tag: "反转", heat: 95, delta: "up" },
  { id: 3, rank: 3, title: "导师席阵型洗牌，首期要提前抢档", tag: "综艺", heat: 92, delta: "new" },
  { id: 4, rank: 4, title: "战绩图表同一份图两边都当证据", tag: "网红", heat: 89, delta: "down" },
  { id: 5, rank: 5, title: "压轴名单连夜重排，红毯前十分钟定稿", tag: "盛典", heat: 84, delta: "up" },
  { id: 6, rank: 6, title: "剧本疑云口型逐帧比对帖刷屏", tag: "综艺", heat: 78, delta: "down" },
  { id: 7, rank: 7, title: "通稿文案撞车被挖出前年旧稿", tag: "通稿", heat: 74, delta: "up" },
  { id: 8, rank: 8, title: "导播收音漏进候场区对话", tag: "现场", heat: 69, delta: "down" },
];

export const columns: ColumnItem[] = [
  {
    id: 1,
    name: "顶流前线",
    desc: "紧盯一线动态，谁在深夜改行程、谁被拍到离场，第一手都不落。",
    cover: "https://readdy.ai/api/search-image?query=glowing%20spotlight%20stage%20with%20a%20distant%20celebrity%20silhouette%20backstage%20at%20night%2C%20amber%20and%20crimson%20rim%20light%2C%20camera%20crew%20in%20shadow%2C%20paparazzi%20front%20line%20mood%2C%20editorial%20entertainment%20cover%2C%20dark%20cohesive%20backdrop&width=800&height=500&seq=g91-c1&orientation=landscape",
    updates: 38,
    watchers: 9200,
    tone: "bg-primary-500",
  },
  {
    id: 2,
    name: "综艺加更房",
    desc: "录制路透、导师席洗牌、剧本疑云，综艺现场每一帧都有人盯着。",
    cover: "https://readdy.ai/api/search-image?query=bright%20variety%20studio%20set%20at%20night%20from%20audience%20view%2C%20empty%20chairs%20and%20spotlit%20platform%2C%20warm%20amber%20wash%20with%20crimson%20edges%2C%20recording%20in%20progress%20mood%2C%20editorial%20entertainment%20cover%2C%20dark%20cohesive%20backdrop&width=800&height=500&seq=g91-c2&orientation=landscape",
    updates: 27,
    watchers: 7400,
    tone: "bg-accent-500",
  },
  {
    id: 3,
    name: "网红一线蹲",
    desc: "连麦翻车、战绩对线、速删原声，网红这条线的瓜永远不缺反转。",
    cover: "https://readdy.ai/api/search-image?query=phone%20glowing%20on%20a%20desk%20in%20darkness%20showing%20live%20chat%20and%20comments%2C%20red%20notification%20glow%2C%20warm%20amber%20rim%20light%2C%20night%20streaming%20mood%2C%20viral%20moment%2C%20editorial%20cover%2C%20dark%20cohesive%20backdrop&width=800&height=500&seq=g91-c3&orientation=landscape",
    updates: 45,
    watchers: 11200,
    tone: "bg-primary-400",
  },
  {
    id: 4,
    name: "舆论反转所",
    desc: "通稿撞车、时间戳比对、文案前后对照，专治各种嘴硬与圆场。",
    cover: "https://readdy.ai/api/search-image?query=documents%20and%20press%20release%20printouts%20pinned%20on%20a%20dark%20wall%20under%20warm%20desk%20lamp%2C%20magnifying%20glass%20and%20red%20pen%2C%20night%20press%20office%2C%20amber%20and%20crimson%20tones%2C%20investigation%20mood%2C%20editorial%20cover%2C%20dark%20cohesive%20backdrop&width=800&height=500&seq=g91-c4&orientation=landscape",
    updates: 19,
    watchers: 8600,
    tone: "bg-secondary-800",
  },
  {
    id: 5,
    name: "花絮内幕库",
    desc: "导播收音、后台对话、改灯改位，那些不该进正片的都在这归档。",
    cover: "https://readdy.ai/api/search-image?query=backstage%20audio%20console%20and%20headphones%20under%20dim%20amber%20light%2C%20sound%20wave%20on%20a%20dark%20monitor%2C%20red%20record%20light%2C%20engineer%20desk%20at%20night%2C%20warm%20crimson%20and%20gold%2C%20behind%20the%20scenes%20mood%2C%20editorial%20cover%2C%20dark%20cohesive%20backdrop&width=800&height=500&seq=g91-c5&orientation=landscape",
    updates: 33,
    watchers: 5100,
    tone: "bg-accent-600",
  },
  {
    id: 6,
    name: "首发速递站",
    desc: "谁先发谁先看，这条道拼的是手速，错过前排等于白吃一瓜。",
    cover: "https://readdy.ai/api/search-image?query=fast%20moving%20light%20streaks%20and%20a%20flashing%20news%20ticker%20on%20a%20dark%20digital%20backdrop%2C%20warm%20amber%20and%20crimson%20speed%20glow%2C%20urgency%20and%20motion%2C%20breaking%20feed%20mood%2C%20editorial%20cover%2C%20dark%20cohesive%20backdrop&width=800&height=500&seq=g91-c6&orientation=landscape",
    updates: 51,
    watchers: 13900,
    tone: "bg-primary-600",
  },
];

export const toolStats = [
  { key: "today", label: "今日首发", value: "86", icon: "ri-flashlight-fill" },
  { key: "hot", label: "热乎中", value: "09", icon: "ri-fire-fill" },
  { key: "twist", label: "正在反转", value: "03", icon: "ri-restart-line" },
  { key: "front", label: "前排在线", value: "2173", icon: "ri-user-heart-fill" },
];